import React from 'react'
import styled from '@emotion/styled'
import { black, blueDark10 } from '../constants/principles'

export const AutoCheckErrorMessage = ({ vin }) => {
  const messages = ['Salvage title or other title issues', 'Flood/water damage', 'Frame damage', 'Mileage or odometer issues', 'Use as a government or livery vehicle']
  return (
    <StyledItem>
      <StyledTitle>Sorry, your vehicle doesn't qualify for an Instant Cash Offer. Vehicles may be ineligible because of: </StyledTitle>
      <StyledOl>
        {messages.map((i, n) => (
          <StyledLi key={n}>{i}</StyledLi>
        ))}
      </StyledOl>
      <StyledTitleBlack>Need the Full Vehicle History?</StyledTitleBlack>
      <StyledTitleBlue data-testid={'bi-btn-see-autocheck-report'}>
        <a href={'https://www.autocheck.com/?siteID=5149&vin=' + vin} target="_blank" rel="noopener noreferrer">
          See the AutoCheck® report
        </a>
      </StyledTitleBlue>
    </StyledItem>
  )
}

const StyledOl = styled.ol`
  padding-left: 10px;
  list-style-type: disc;
`
const StyledLi = styled.li`
  height: 2.2rem;
`
const StyledTitle = styled.div`
  font-size: 1.5rem;
`

const StyledTitleBlack = styled.div`
  font-size: 1.5rem;
  color: ${black};
  font-weight: '700';
  padding-left: 10px;
`

const StyledTitleBlue = styled.div`
  font-size: 1.5rem;
  color: ${blueDark10};
  padding-left: 25px;
  font-weight: '700';
`

const StyledHyperLink = styled.a`
  /* unvisited link */
  a:link {
    color: red;
  }

  /* visited link */
  a:visited {
    color: green;
  }

  /* mouse over link */
  a:hover {
    color: hotpink;
  }

  /* selected link */
  a:active {
    color: blue;
  }
`

const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding-left: 10px;
`
